import { render, staticRenderFns } from "./customer-list-page.vue?vue&type=template&id=ddcb27a8&"
import script from "./customer-list-page.vue?vue&type=script&lang=js&"
export * from "./customer-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports